export default {
  login: {
    title: 'Sign In',
    username: 'Username',
    phone: 'Phone Number',
    phoneCode: 'Code',
    email: 'Email',
    password: 'Password',
    captcha: 'Captcha',
    loading: 'Loading...',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot Password?',
    loginButton: 'Sign In',
    contactUs: 'Contact Us？',
    noAccount: "Don't have an account?",
    registerNow: 'Sign Up',
    or: 'OR',
    orSignInWith: 'Or Sign In with',
    methodUsername: 'Username',
    methodPhone: 'Phone',
    methodEmail: 'Email',
    // Errors
    usernameRequired: 'Username is required',
    phoneRequired: 'Phone number is required',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    captchaRequired: 'Captcha is required',
    // Reset Password
    resetPassword: 'Reset Password',
    resetStep1Hint: 'Enter your phone number or email to receive a verification code.',
    useEmailInstead: 'Use email instead',
    usePhoneInstead: 'Use phone instead',
    sendCode: 'Send Code',
    resetStep2Hint: 'A verification code has been sent to',
    verificationCode: 'Verification Code',
    verificationCodeRequired: 'Verification code is required',
    resendIn: 'Resend in',
    resendCode: 'Resend Code',
    verify: 'Verify',
    resetStep3Hint: 'Set your new password.',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordMinLength: 'Password must be at least 6 characters',
    confirmPasswordRequired: 'Please confirm your password',
    passwordMismatch: 'Passwords do not match',
    resetPasswordBtn: 'Reset Password',
    back: 'Back',
    // Format validation
    emailFormat: 'Invalid email format',
    // Toast messages
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    signInWithGoogle: 'Sign In with Google+',
    codeSent: 'Verification code sent',
    sendCodeFailed: 'Failed to send code',
    invalidCode: 'Invalid verification code',
    resetSuccess: 'Password reset successfully',
    resetFailed: 'Failed to reset password'
  }
};
